import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()({
  supportHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '1rem',
  },
});


